<template>
  <div class="box content">
    <h1 class="title">Verify User's Contact Info</h1>

    <div class="box is-clipped is-paddingless">
      <div class="hero is-info is-bold">
        <div class="hero-body has-text-centered">
          <h2 class="title is-3">We have just sent an email to the Customer.</h2>
          <p>Once the customer has confirmed their account, you will be allowed to proceed.</p>
        </div>
      </div>
    </div>

    <div class="field is-grouped is-grouped-right">
        <p class="control">
          <button type="submit" class="button is-success" :disabled="!canProceed" @click="onProceed">Next Step</button>
        </p>
      </div>
  </div>
</template>

<script>
export default {
  name: 'CreateCustomerStepTwo',

  props: {
    customerId: {
      required: false
    }
  },

  data () {
    return {
      isUsingExistingLocation: false,
      canProceed: false
    }
  },

  mounted () {
    setTimeout(() => {
      this.canProceed = true
    }, 3000)
  },

  methods: {
    onProceed () {
      this.$router.push({
        name: 'Create Pickup Location',
        params: {
          customerId: this.customerId
        }
      })
    }
  }
}
</script>
